import { render, staticRenderFns } from "./render-input-group-arr.vue?vue&type=template&id=081820b7&"
import script from "./render-input-group-arr.vue?vue&type=script&lang=js&"
export * from "./render-input-group-arr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports